export function setupMenu(): void {
    const toggles = document.querySelectorAll<HTMLElement>('.header .navbar-nav .dropdown-toggle');

    function setOpenToggle(toggle: HTMLElement): void {
        toggle.setAttribute('aria-expanded', 'true');
    }

    function setClosedToggle(toggle: HTMLElement): void {
        toggle.setAttribute('aria-expanded', 'false');
    }

    function keyboardFunctions(anchors: NodeListOf<HTMLElement>, toggle: HTMLElement, parent: HTMLElement): void {
        const $anchors = $(anchors);

        if (document.activeElement === $anchors.last()[0]) {
            parent.classList.remove('open');
            setClosedToggle(toggle);
        }
    }

    toggles.forEach((toggle) => {
        const dropdown = toggle.nextElementSibling as HTMLElement | null;
        if (!dropdown) return;

        const dropdownAnchors = dropdown.querySelectorAll<HTMLElement>('a');
        const parent = toggle.parentNode as HTMLElement;

        dropdownAnchors.forEach((anchor) => {
            anchor.addEventListener('keydown', function () {
                keyboardFunctions(dropdownAnchors, toggle, parent);
            });
        });

        toggle.addEventListener('click', function () {
            setTimeout(function () {
                if (parent.classList.contains('open')) {
                    setOpenToggle(toggle);
                } else {
                    setClosedToggle(toggle);
                }
            }, 50);
        });
    });
}
